<template>
    <b-modal size="lg" ref="createNewItemModal" hide-footer :title="$t('scdda_admin.editspend.header')">
        <b-container>
            <b-row>
                <b-col>
                    <b-form-group :label="$t('scdda_admin.editspend.year')" label-for="year">
                        <b-form-input id="year" type="text" :state="!$v.currentItem.year_id.$error ? null : false" v-model="currentItem.year_id" style="background-color: #fdfdfd"></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('scdda_admin.editspend.user')" label-for="user">
                        <b-form-input id="user" type="text" :state="!$v.currentItem.user_id.$error ? null : false" v-model="currentItem.user_id" style="background-color: #fdfdfd"></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('scdda_admin.editspend.spend')" label-for="spend">
                        <b-form-input id="spend" type="text" :state="!$v.currentItem.spend.$error ? null : false" v-model="currentItem.spend" style="background-color: #fdfdfd"></b-form-input>
                    </b-form-group>
                    <!-- <b-form-group :label="$t(`spendmodal.analysis_enabled`)" label-for="analysis_enabled">
                        <b-form-checkbox id="analysis_enabled" :state="!$v.currentItem.analysis_enabled.$error ? null : false" v-model="currentItem.analysis_enabled" style="background-color: #fdfdfd"></b-form-checkbox>
                    </b-form-group>-->
                </b-col>
            </b-row>
        </b-container>
        <b-button class="button-margin mt-3" variant="primary" block @click="createItem">{{ $t("scdda_admin.editspend.save") }}</b-button>
    </b-modal>
</template>
    <script>
    import SpendService from '../../../../../services/Riskmanagement/SpendService';
    import { helpers, required } from 'vuelidate/lib/validators';
    export default {
        name: 'spend-modal',
        props: ['savedCallback'],
        data() {
            return {
                currentItemEditMode: false,
                currentItem: {}
            }
        },
        validations: {
            currentItem: {
                year_id:               {required},
                user_id:               {required},
                spend:                 {required},
                analysis_enabled:      {required},
            }
        },
        methods: {
            enterEditMode() {
                this.currentItemEditMode = true;
            },
            leaveEditMode() {
                this.currentItemEditMode = false;
            },
            showModal() {
                this.$v.$reset();
                this.currentItemEditMode = false;
                this.$refs.createNewItemModal.show();
            },
            hideModal() {
                this.$refs.createNewItemModal.hide();
                this.currentItem = {};
                this.$v.$reset();
            },
            setItem(Item) {
                this.currentItem = Item;
            },
            createItem() {
                this.$v.$touch();

                if(this.$v.$error) {
                    return;
                }

                this.$store.commit('loading/setLoading', true);

                if(!this.currentItemEditMode) {
                    SpendService.create(this.currentItem)
                        .then(response => {
                            this.$notify({
                                group: 'global',
                                title: this.$t("scdda_admin.editspend.success_title"),
                                type: 'success',
                                text: this.$t("scdda_admin.editspend.success_message")
                            });

                            this.$store.commit('loading/setLoading', false);

                            if(this.savedCallback){
                                this.savedCallback();
                            }

                            this.$refs.createNewItemModal.hide();
                            this.currentItem = {};
                        })
                        .catch(error => {
                            this.$store.commit('loading/setLoading', false);
                            this.$notify({
                                group: 'global',
                                title: this.$t("scdda_admin.editspend.error_title"),
                                type: 'error',
                                text: error.message
                            });
                        });
                }else {
                    SpendService.update(this.currentItem.id, this.currentItem)
                        .then(response => {
                            this.$notify({
                                group: 'global',
                                title: this.$t("scdda_admin.editspend.success_title"),
                                type: 'success',
                                text: this.$t("scdda_admin.editspend.success_message")
                                });

                            if(this.savedCallback){
                                this.savedCallback();
                            }

                            this.$refs.createNewItemModal.hide();
                            this.currentItem = {};
                        })
                        .catch(error => {
                            this.$store.commit('loading/setLoading', false);
                            this.$notify({
                                group: 'global',
                                title: this.$t("scdda_admin.editspend.error_title"),
                                type: 'error',
                                text: error.message
                            });
                        });
                }
            }
        }
    }
    </script>
